import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GradientButton } from '../../components/Buttons';
import {
  IconArrowRight,
  IconBook,
  IconCreditCard,
  IconKey,
  IconLockPassword,
  IconSparkles,
  IconVariable,
  IconVersions,
} from '@tabler/icons-react';
import { Footer } from '../../components/Footer';

function Landing() {
  useEffect(() => {
    document.title = 'PromptSlate | Prompt management and version control made easy';
  }, []);
  return (
    <div className="flex flex-col w-full items-center h-fit">
      <div className="w-full h-[45px] flex justify-center border-b">
        <div className="w-full max-w-5xl h-full flex items-center justify-between text-sm">
          <div>Introducting PromptSlate</div>
          <Link to="/signup">
            <div className="flex flex-row">
              Get started now <IconSparkles size="1rem" className="ml-2 mt-0.5" />
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full max-w-5xl mt-2 mb-12">
        <div className="w-full max-w-5xl h-[70px] flex items-center justify-between">
          <div>
            <Link to="/">
              <img
                src="/logo_black.png"
                alt="PromptSlate logo"
                className="h-[30px] object-contain"
              />
            </Link>
          </div>
          <div className="flex flex-row">
            <Link to="/api-docs">
              <div className="flex flex-row mr-5 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconBook size="1.5rem" className="mr-1" /> Docs
              </div>
            </Link>
            <Link to="/pricing">
              <div className="flex flex-row mr-4 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconCreditCard size="1.5rem" className="mr-1" /> Pricing
              </div>
            </Link>
            <Link to="/login">
              <div className="flex flex-row p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconKey size="1.5rem" className="mr-1" /> Login
              </div>
            </Link>
          </div>
        </div>
        <div className="mt-12">
          <div className="max-w-[50%] text-5xl font-semibold leading-[55px]">
            Ship AI Changes in Seconds - Effortless Prompt Management & Version Control
          </div>
          <Link to="/signup">
            <GradientButton className="mt-8 h-[55px] hover:shadow-xl transition-all duration-300 ease-in-out">
              {' '}
              <div className="flex flex-row text-lg">
                Get started now <IconArrowRight size="1.5rem" className="ml-2 mt-0.5" />
              </div>
            </GradientButton>
          </Link>
        </div>
        <div className="mt-16 flex flex-col">
          <div>
            <div className="flex flex-col pt-4 pb-6">
              <div className="flex flex-row items-center">
                <div className="bg-black text-white w-[40px] h-[40px] rounded-full p-2">
                  <IconVersions size="1.5rem" />
                </div>
                <span className="ml-2 text-2xl">Easy version control</span>
              </div>
              <span className="ml-[50px] text-slate-600">
                Stay in control with built-in version history. See edits, who made them, and roll
                back anytime if needed.
              </span>
            </div>
            <img
              src="images/previews/version-control.png"
              alt="Verson control prompts and rollback if needed"
              className="w-full object-contain rounded-lg hover:shadow-lg transition-all duration-300 ease-in-out"
            />
          </div>
          <div className="mt-8">
            <div className="flex flex-col pt-4 pb-6">
              <div className="flex flex-row items-center">
                <div className="bg-black text-white w-[40px] h-[40px] rounded-full p-2">
                  <IconVariable size="1.5rem" />
                </div>
                <span className="ml-2 text-2xl">Dynamic data ingestion</span>
              </div>
              <span className="ml-[50px] text-slate-600">
                Ingest custom data on the fly using predefined variables — flexible and fast
              </span>
            </div>
            <img
              src="images/previews/variable.png"
              alt="Ingest custom data into prompts using variables"
              className="w-full object-contain rounded-lg hover:shadow-lg transition-all duration-300 ease-in-out"
            />
          </div>
          <div className="mt-8">
            <div className="flex flex-col pt-4 pb-6">
              <div className="flex flex-row items-center">
                <div className="bg-black text-white w-[40px] h-[40px] rounded-full p-2">
                  <IconLockPassword size="1.5rem" />
                </div>
                <span className="ml-2 text-2xl">Granular API key management</span>
              </div>
              <span className="ml-[50px] text-slate-600">
                Manage access with precision — create API keys with custom scopes, set permissions,
                and revoke access anytime. Total control.
              </span>
            </div>
            <img
              src="images/previews/key-management.png"
              alt="API Key and permission management"
              className="w-full object-contain rounded-lg hover:shadow-lg transition-all duration-300 ease-in-out"
            />
          </div>
        </div>
      </div>
      <div className="w-full h-[400px] border-t mt-12 flex flex-col justify-center items-center">
        <div className="flex flex-row max-w-5xl justify-between">
          <div className="max-w-[45%]">
            <div>
              <img
                src="/logo_black.png"
                alt="PromptSlate logo"
                className="h-[40px] object-contain"
              />
            </div>
            <div className=" text-5xl font-semibold leading-[55px] mt-12">
              Supercharge Your Workflow by managing prompts like a pro today
            </div>
          </div>
          <div className="flex items-center">
            <Link to="/signup">
              <GradientButton className="h-[55px] hover:shadow-xl transition-all duration-300 ease-in-out">
                {' '}
                <div className="flex flex-row text-lg">
                  Get started now <IconArrowRight size="1.5rem" className="ml-2 mt-0.5" />
                </div>
              </GradientButton>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Landing;
